// ============================================================================
// COLORS
// ============================================================================

// Helixa AI color theme - Emerald Green
export const EMERALD_DARK = "#1a4d3e";
export const EMERALD_MID = "#2d6a53";
export const EMERALD_LIGHT = "#3d8b6e";

/**
 * COLORS — JS/TS renk sabitleri.
 * Degerler tokens.css ile senkronize tutulmalidir.
 * CSS tarafinda var(--color-*) kullanin; bu obje yalnizca
 * inline style veya JS hesaplamalari icindir.
 */
export const COLORS = {
  // ── Primary ──
  primary: "#1a4d3e",
  primaryMid: "#2d6a53",
  primaryLight: "#3d8b6e",
  primaryLighter: "rgba(26, 77, 62, 0.1)",
  primaryDarker: "#143d30",
  primaryAlpha15: "rgba(26, 77, 62, 0.15)",

  // ── Background / Surface ──
  background: "#f8f9fa",
  surface: "#f9fafb",
  surfaceSecondary: "#f3f4f6",
  cardBg: "#fafafa",
  cardHover: "#f0f1f3",
  white: "#ffffff",
  whiteAlpha20: "rgba(255, 255, 255, 0.2)",
  whiteAlpha32: "rgba(255, 255, 255, 0.32)",
  whiteAlpha80: "rgba(255, 255, 255, 0.8)",

  // ── Text ──
  textPrimary: "#111827",
  textSecondary: "#6b7280",
  textSecondaryDark: "#374151",
  textMuted: "#9ca3af",
  textDark: "#333333",
  textGray: "#666666",
  textLightGray: "#888888",
  textBody: "#4b5563",
  textPlaceholder: "#999999",
  textDisabled: "#cccccc",

  // ── Border ──
  border: "#e5e7eb",
  borderLight: "#f0f0f0",
  borderMid: "#ced4da",
  borderSecondary: "#d1d5db",
  inputBorder: "#e1e5e9",

  // ── Input ──
  inputBackground: "#f9f9f9",
  spinnerTrack: "#f3f3f3",

  // ── Hover / Interaction ──
  hoverBg: "#e5e5e5",
  hoverBgLight: "#e9ecef",
  hoverBgSubtle: "#f3f4f6",

  // ── Label / Badge ──
  labelDefault: "#E9EDF1",

  labelBlue: "#DBEAFE",
  labelIndigo: "#E0E7FF",
  labelPurple: "#EDE9FE",
  labelPink: "#FCE7F3",
  labelRed: "#FEE2E2",
  labelOrange: "#FFEDD5",
  labelAmber: "#FEF3C7",
  labelYellow: "#FEF9C3",
  labelLime: "#ECFCCB",
  labelGreen: "#DCFCE7",
  labelTeal: "#CCFBF1",
  labelCyan: "#CFFAFE",
  labelSky: "#E0F2FE",
  labelSlate: "#F1F5F9",

  // ── Semantic ──
  delete: "#dc2626",
  error: "#dc2626",
  errorLight: "#fef2f2",
  errorHover: "#ffe0e0",
  errorText: "#ff4444",
  errorBg: "#fff5f5",
  dangerBorder: "#fecaca",
  successBg: "#f0fdf4",
  successBgDark: "#dcfce7",
  successText: "#166534",
  successStrong: "#059669",
  warningBg: "#fff7ed",
  warningText: "#c2410c",
  pdf: "#8f120b",
  word: "#2b579a",
  gold: "#c7a56c",
  goldLight: "rgba(199, 165, 108, 0.1)",
};

export const TASK_COLORS = [
  "#7fa8f4",
  "#6dcb9f",
  "#b094ec",
  "#f4b27d",
  "#e98dbc",
  "#78bee0",
  "#8f9bef",
  "#e3bb68",
  "#e98a8a",
  "#70c0b7",
];
